import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../../auth/services/auth.service';
import { FeatureFlagService } from '../../../../feature-flags';
import { NxUserAvatar } from '../../../../../shared/ui/user-avatar/user-avatar';

@Component({
  selector: 'app-sidenav-user-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    NxUserAvatar,
  ],
  templateUrl: './sidenav-user-menu.html',
  styleUrl: './sidenav-user-menu.scss',
})
export class SidenavUserMenu {
  private readonly authService = inject(AuthService);
  readonly flagService = inject(FeatureFlagService);
  
  expanded = input<boolean>(true);

  // Dados do usuário autenticado
  protected readonly user = this.authService.user;
  protected readonly userName = computed(() => this.user()?.name || 'Usuário');
  protected readonly userFotoBase64 = computed(() => this.user()?.fotoBase64);
  protected readonly userNomeGuerra = computed(() => this.authService.getNomeGuerra() || this.userName());
  protected readonly userPosto = computed(() => this.authService.getPosto() || '');
  protected readonly userUnit = computed(() => this.user()?.sgpol?.upm || this.user()?.unidade || '');

  onLogout(): void {
    this.authService.logout();
  }
}
